module.exports = __webpack_public_path__ + "static/media/warning.a431eaad.mp3";